import * as React from "react";

import { Block } from "../Block";
import { Image } from "../Image";
import { LabelLarge } from "../typography";

const BaseOption: React.FC<TSelectable & { control?: React.ReactNode }> = (props) => {
  const { icon, title, control, selected } = props;

  return (
    <Block
      paddingTop={["scale400", "scale400", "scale800"]}
      paddingRight="scale400"
      paddingBottom={["scale400", "scale400", "scale800"]}
      paddingLeft="scale400"
      marginBottom={[0, 0, "scale600"]}
      display="flex"
      alignItems="center"
      flexDirection={["row", "row", "column"]}
    >
      <Image
        src={icon}
        width={["50px", "50px", "74px"]}
        height={["50px", "50px", "74px"]}
        flex="0 0 auto"
        marginBottom={[0, 0, "scale800"]}
        marginRight={["scale800", "scale800", 0]}
        strictRatio
      />
      <LabelLarge
        flex={1}
        marginBottom={[0, 0, "scale800"]}
        marginRight={["scale400", "scale400", 0]}
        center={[false, false, true]}
        overrides={{
          Block: {
            style: {
              fontWeight: selected ? 600 : 300,
            },
          },
        }}
      >
        {title}
      </LabelLarge>
      {control}
    </Block>
  );
};

export { BaseOption };
